import { ClientProfileData } from '~admin/model/client-profile-data';
import { ClientProfileResponse } from '~client/model/client-profile-response';

export const mapClientProfileData = (response: ClientProfileResponse): ClientProfileData => {
  const { id, name } = response;

  return {
    id: Number(id),
    name,
  };
};

export const mapClientProfileDataList = (response: ClientProfileResponse[]): ClientProfileData[] =>
  response.map(mapClientProfileData);



// WEBPACK FOOTER //
// ./model/client-profile-data.mapper.ts